import React from 'react';
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined';
import NotificationsOutlinedIcon from '@material-ui/icons/NotificationsOutlined';
import { Review, Wallet } from '@carbon/icons-react';
import { colorSet } from '@components/Provider';

export interface IProfileMenu {
  menu: string;
  url: string;
  urlParam?: string;
  userLog?: string;
  logo?: React.ReactNode;
}

export const routes: Array<IProfileMenu> = [
  {
    menu: '내 정보 관리',
    url: '/mypage/profile',
    userLog: 'Button_Gnb_Popup_Profile',
    logo: <AccountCircleOutlinedIcon />
  },
  {
    menu: '계좌 관리',
    url: '/mypage/backAccount',
    logo: <Wallet size={24} />
  },
  {
    menu: '알림설정',
    url: '/mypage/notification',
    userLog: 'Button_Gnb_Popup_Notification',
    logo: <NotificationsOutlinedIcon />
  },
  {
    menu: '리뷰관리',
    url: '/mypage/review',
    userLog: 'Button_Gnb_Popup_Notification',
    logo: <Review size={24} color={colorSet.gray900} />
  }
];
